import { gql } from "graphql-request";

export const READ_SINGLE_PROJECT_BY_ID = gql`
  query ReadSingleProjectById($id: ID!) {
    readSingleProjectById(id: $id) {
      id
      title
      isSOPTemplate
      description
      labels
      tenantId
      sourceProjectId
      dueDate
      status
      createdAt
      updatedAt
      archivedAt
      tasks {
        id
        title
        tenantId
        projectId
        accountableRoleId
        assignedTenantUserId
        status
        sequence
        labels
        dueDate
        deferDate
        plannedDurationMin
        actualDurationMin
        createdAt
        updatedAt
        archivedAt
      }
    }
  }
`;

export const READ_PROJECTS_FILTER = gql`
  query ReadProjectsFilter(
    $filter: ProjectFilterInput
  ) {
    readProjectsFilter(filter: $filter) {
      id
      title
      isSOPTemplate
      description
      labels

      tenantId

      sourceProjectId
      sourceProject {
        id
        title
      }

      approvalStatus
      approvedAt
      approvedByUserId

      approvalAssignments {
        id
        tenantId
        projectId
        approverUserId
        status
        rejectionReason
        approvedAt
        rejectedAt
        createdAt
        updatedAt

        approverUser {
          id
          userId
          displayName

          user {
            id
            firstName
            lastName
            email
          }
        }
      }

      dueDate
      status

      createdAt
      updatedAt
      archivedAt

      tasks {
        id
        isLatest
      }
    }
  }
`;

export const READ_PROJECT = gql`
  query ReadSingleProjectById($id: ID!) {
    readSingleProjectById(id: $id) {
      id
      title
      isSOPTemplate
      description
      labels
      tenantId
      approvalStatus
      approvedAt
      approvedByUserId
      sourceProjectId
      sourceProject {
        id
        title
      }
      dueDate
      status
      createdAt
      updatedAt
      archivedAt
      tasks {
        id
        title
        description
        status
        sequence
        labels
        projectId

        accountableRoleId

        assignedTenantUserId
        assignedTenantUser {
          id
          user {
            id
            firstName
            lastName
            hourlyRate
          }
        }

        dueDate
        deferDate
        cost
        imageUrls
        plannedDurationMin
        actualDurationMin
        versionMajor
        versionMinor
        isLatest
      }
    }
  }
`;

// minimal project meta for filtering
export const GET_PROJECT_META = gql`
  query {
    readProjectsFilter(filter: { sop: false }) {
      id
      title
      description
      labels
      assignedTo
      dueDate
      status
      department
      business
      tasks {
        id
      }
    }
  }
`;

export const GET_SOP_PROJECTS = gql`
  query ReadSOPProjects($tenantId: ID!) {
    readProjectsFilter(
      filter: { tenantId: $tenantId, isSOPTemplate: true }
    ) {
      id
      title
      isSOPTemplate
      tenantId
      status
      approvalStatus
    }
  }
`;


export const READ_SOP_LIBRARY_FILTER_DATA = gql`
  query ReadSopLibraryFilterData($input: ReadRoleAllocationBoardInput!) {
    readRoleAllocationBoard(input: $input) {
      tenantId

      departments {
        id
        tenantId
        name
        description
      }

      roles {
        role {
          id
          name
          departmentId
        }

        peopleCards {
          tenantUser {
            id
            userId
          }

          displayName
          isPrimary
        }

        sopCards {
          sop {
            id
            title
            description
            status
            
            isSOPTemplate
            approvalStatus

            tasks {
              id
              status
              isLatest
            }
          }

          tenantRole {
            id
            name
          }
        }
      }
    }
  }
`;


export const READ_SOPS_AWAITING_ADMIN_APPROVAL = gql`
  query ReadSOPsAwaitingAdminApproval(
    $filter: ProjectFilterInput
  ) {
    readSOPsAwaitingAdminApproval(
      filter: $filter
    ) {
      id
      title
      description
      approvalStatus
      tenantId

      sopRoleAssignments {
        id
        tenantRole {
          id
          name
        }
      }

      approvalAssignments {
        id
        tenantId
        projectId
        approverUserId
        status
        rejectionReason
        approvedAt
        rejectedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const READ_MY_SOPS_TO_APPROVE = gql`
  query ReadMySOPsToApprove($tenantId: ID!, $userId: ID!) {
    readMySOPsToApprove(tenantId: $tenantId, userId: $userId) {
      id
      title
      description
      approvalStatus
      tenantId
    }
  }
`;